import React from "react";
import { connect } from "react-redux";

import NavBaseTemplate from "../templates/NavBaseTemplate";
import FeedbackTile from "../theme/modals/FeedbackTile";
import Tabs from "../theme/menus/Tabs";
import UsersTab from "./admin/UsersTab";
import OfficesTab from "./admin/OfficesTab";
import CampaignsTab from "./admin/CampaignsTab";
import WebhooksTab from "./admin/WebhooksTab";
import { withRouter } from "../../utils/withRouter";

const ADMIN_SECTIONS = ["users", "offices", "campaigns", "webhooks"];
const DEFAULT_ADMIN_SECTION = "users";

class AdminScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      errMsg: "Something went wrong.",
      showSuccess: false
    };

    this._setError = this._setError.bind(this);
    this._showSuccess = this._showSuccess.bind(this);
  }

  _setError = (errMsg) => {
    this.setState({ error: true, errMsg })
    setTimeout(() => this.setState({ error: false, errMsg: "Something went wrong." }), 8000);    
  };

  _showSuccess = () => {
    this.setState({ showSuccess: true });
    setTimeout(() => this.setState({ showSuccess: false }), 8000);
  };

  _getSection = () => {
    const section = this.props.params?.section;
    if (section && ADMIN_SECTIONS.includes(section)) {
      return section;
    }
    return DEFAULT_ADMIN_SECTION;
  };

  _navigateToSection = (section) => {
    this.props.navigate(`/admin/${section}`);
  };

  _isError = () => {
    const { props } = this;
    return (
      props.users_error ||
      props.campaigns_error ||
      props.offices_error ||
      this.state.error
    );
  };

  _isLoading = () => {
    const { props } = this;
    return (
      props.users_loading ||
      props.campaigns_loading ||
      props.offices_loading ||
      this.state.loading
    );
  };

  render() {
    const section = this._getSection();
    const sharedProps = {
      setError: this._setError,
      showSuccess: this._showSuccess,
      ...this.props
    };

    return (
      <NavBaseTemplate>
        <Tabs
          tabs={[
            {
              display: "Users",
              onClick: () => this._navigateToSection("users"),
              active: section === "users",
            },
            {
              display: "Offices",
              onClick: () => this._navigateToSection("offices"),
              active: section === "offices",
            },
            {
              display: "Campaigns",
              onClick: () => this._navigateToSection("campaigns"),
              active: section === "campaigns",
            },
            {
              display: "Webhooks",
              onClick: () => this._navigateToSection("webhooks"),
              active: section === "webhooks",
            }
          ]}
        />

        {section === "users" && <UsersTab {...sharedProps} />}
        {section === "offices" && <OfficesTab {...sharedProps} />}
        {section === "campaigns" && <CampaignsTab {...sharedProps} />}
        {section === "webhooks" && <WebhooksTab {...sharedProps} />}

        <FeedbackTile
          text={
            <div>
              <i className="fas fa-asterisk fa-spin" style={{ marginRight: "15px" }} />
              Loading...
            </div>
          }
          visible={this._isLoading()}
        />
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-check-circle" style={{ marginRight: "15px" }} />
              Success
            </div>
          }
          visible={this.state.showSuccess}
          classNames="success"
        />
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: "15px" }} />
              {this.state.errMsg}
            </div>
          }
          visible={this._isError()}
          classNames="danger"
        />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => {
  const newState = {
    campaigns: state.campaigns.data,
    memberships: state.permissions.memberships,
    campaigns_error: state.campaigns.error,
    campaigns_loading: state.campaigns.loading,
    focusedCampaign: state.session.focusedCampaign,
    offices: state.offices.data,
    offices_error: state.offices.error,
    offices_loading: state.offices.loading,
    users: state.users.data,
    deactivated_users: state.users.inactiveData,
    users_error: state.users.error,
    users_loading: state.users.loading,
    is_admin: state.permissions.is_admin,
    canViewInactive: state.permissions.is_staff || state.permissions.is_superuser || state.permissions.is_admin,
    webhooks: state.alertConfigs.webhooks,
  };

  return newState;
};

export default connect(mapStateToProps)(withRouter(AdminScreen));
